import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'OriensCRM',
    logo: require('@/assets/images/svg/logo.png'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'full',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: true,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'hidden', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#6285F6',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FFB400',
      error: '#F44336',
    },
    dark: {
      primary: '#6285F6',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#4CAF50',
      info: '#2196F3',
      warning: '#FFB400',
      error: '#F44336',
    },
  },
}

export default themeConfig
